// ============= Constants =============

export const FORM_SECTION_DEPENDENCY_FIELDS = ['payments_count'] as const;

export const SECTION_SCHEMA_REFRESH_FIELDS: Record<string, readonly string[]> = {
  overtime_approval_line_manager: ['confirm_approval_overtime_request'],
  gift_hospitality_donation_uk_request_details: [
    'givenReceivedByPerson',
    'partyDetails',
  ],
  gift_hospitality_donation_dubai_request_details: [
    'givenReceivedByPerson',
    'partyDetails',
  ],
  gift_hospitality_donation_dublin_request_details: [
    'givenReceivedByPerson',
    'partyDetails',
  ],
};

export const REJECTION_CREATOR_MESSAGE =
  'This form has been rejected. Please re-submit or cancel.';

export const REJECTION_NON_CREATOR_MESSAGE_PREFIX =
  'This form has been rejected. The Creator';

export const CANCELLATION_MESSAGE =
  'This workflow has been cancelled and is no longer active.';

export const PAYMENT_HOLD_REVIEW_MESSAGE =
  'This payment is on hold (awaiting funds/satisfaction of completion conditions). If a payment is held, the payment request is returned to the responsible lawyer, who can resubmit it when the payment is ready to be processed.';

export const UNAUTHORISED_SECTION_MESSAGE =
  'You are not authorised to make any changes to this section';

export const DEFAULT_PERMISSION_DENIED_MESSAGE =
  'Access denied: You do not have permission to access this workflow.';
